/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import DateSelect from './DateSelect/index'
import LocationSelect from './LocationSelect/index'
import React from 'react'
import SlotSelect from './SlotSelect/index'
import UntemplatedSlot from './UntemplatedSlot/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old/ScheduleOptions/Content"
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let tabSchedulingUntemplatedSlotDateValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'scheduling.untemplated_slot.date',
})
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs}}
 className={`views-block ${styles.Vertical1}`}
>
<DateSelect
  viewPath={`${viewPath}/DateSelect`}
/>
<LocationSelect
  viewPath={`${viewPath}/LocationSelect`}
/>
</div>
<SlotSelect
  viewPath={`${viewPath}/SlotSelect`}
/>
<fromFlow.When is={tabSchedulingUntemplatedSlotDateValueData}>
<div
  data-testid="Content.Vertical:2"
  data-view-path={viewPath}
 className="views-block"
>
<UntemplatedSlot
  viewPath={`${viewPath}/UntemplatedSlot`}
/>
</div>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}